import React, { useState } from 'react';
import { GenPage, SegmentControl } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const Scrollings = () => {
  const t = useT();
  const [count, setCount] = useState('10');

  return (
    <GenPage
      title={t('page.scrollings.title')}
      contentType="scrollings"
      description={t('page.scrollings.desc')}
      outputLabel={t('page.scrollings.output')}
      extraOptions={
        <div className="flex items-center gap-1.5">
          <span className="text-xs text-gray-500 font-medium whitespace-nowrap">{t('label.count')}</span>
          <SegmentControl
            options={['5', '10', '20']}
            value={count}
            onChange={setCount}
          />
        </div>
      }
      extraInstructions={`Number of scrolling tickers to generate: ${count}`}
    />
  );
};
